import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AdminServiceService } from 'src/app/services/admin-service.service';
import { ChasideService } from 'src/app/services/chaside.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-chaside-questions',
  templateUrl: './chaside-questions.component.html',
  styleUrls: ['./chaside-questions.component.css']
})
export class ChasideQuestionsComponent implements OnInit {

  public questions = [];
  public isEditing = false;
  public editingId;
  public chasideForm = this.fb.group({
    title:[''],
    group:["Intereses"],
    scale:['C'],
    index:[999],
  })

  constructor(
    private chasideService:ChasideService,
    private adminService:AdminServiceService,
    private fb:FormBuilder
  ) { }

  ngOnInit(): void {
    this.chasideService.getQuestions().subscribe(
      resp=>{
        if (resp) this.questions = resp
      },
      err=>console.log(err)
    )
  }

  register(){
    if (this.isEditing){
      let obj = this.chasideForm.value;
      obj._id = this.editingId;
      this.chasideService.updateQuestion(obj).subscribe(
        resp=>{
          Swal.fire({
            icon:'success',
            text:'Pregunta actualizada'
          }).then(
            resp=>{
              location.reload()
            }
          )
        },
        err=>console.log(err)
      )
    }else{
      this.chasideService.createQuestion(this.chasideForm.value).subscribe(
        resp=>{
          this.questions.push(resp)
          Swal.fire({
            icon:'success',
            text:'Pregunta creada'
          })
          this.chasideForm.reset();
          this.chasideForm.get('index').setValue(999);
          this.chasideForm.get('group').setValue('Intereses');
        },
        err=>console.log(err)
      )
    }
  }

  handleEdit(q){
    this.editingId = q._id;
    this.isEditing = true;
    this.chasideForm.get('title').setValue(q.title);
    this.chasideForm.get('scale').setValue(q.scale);
    this.chasideForm.get('index').setValue(q.index);
    this.chasideForm.get('group').setValue(q.group);
    window.scrollTo(0, document.body.scrollHeight);
  }

  handleDelete(id, i){
    Swal.fire({
      icon:'question',
      text:'¿Borrar pregunta?',
      showCancelButton:true
    }).then(
      resp=>{
        if (resp.isConfirmed){
          this.adminService.deleteQuestion('chaside',id);
        }
      }
    )
  }

}
